import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Carousel, Col, Divider, Row} from "antd";
import {getPartner} from "../Home/service";
import globalStyle from "../../styles/globalStyle";
import ContentReserve from './contentReserve';

const ContentPartner = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        (async () => {
            const { data } = await getPartner({page: 1, size: 100});
            const { list } = data!=null?data:[];
            const tmp = [];
            for(let i = 0; i < list.length; i = i + 4) {
                tmp.push({
                    one: list[i],
                    two: list[i+1],
                    three: list[i+2],
                    four: list[i+3],
                })
            }
            // console.log(tmp)
            setData(tmp)
        })();
    }, []);

    return(
        <div style={{...globalStyle.flexCenterRow,display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#ffffff', marginBottom: 16,maxWidth: 1200}}>
            <div style={{...globalStyle.flexSpaceBetweenColumn,maxWidth: '100%'}}>
                <img src={require('../../images/partner_title_img.png')} style={{marginTop: 24}}/>
                <Divider style={{width: 1180, minWidth: 0}}/>
                <div style={{paddingBottom: 24, width: 1200}}>
                    {
                        data.length > 0
                            ?   <Carousel autoplay dotPosition="right" dots={false} >
                                    {data.map((item, index) => {
                                        const {one, two, three, four} = item;
                                        return(
                                            <div key={index}>
                                                <Row>
                                                    <Col span={6} style={{...globalStyle.flexCenterRow}}>
                                                        {one && <img style={{width: 140, height: 70}} src={one.logo}/> }
                                                    </Col>
                                                    <Col span={6} style={{...globalStyle.flexCenterRow}}>
                                                        {two && <img style={{width: 140, height: 70}} src={two.logo}/> }
                                                    </Col>
                                                    <Col span={6} style={{...globalStyle.flexCenterRow}}>
                                                        {three && <img style={{width: 140, height: 70}} src={three.logo}/> }
                                                    </Col>
                                                    <Col span={6} style={{...globalStyle.flexCenterRow}}>
                                                        {four && <img style={{width: 140, height: 70}} src={four.logo}/> }
                                                    </Col>
                                                </Row>
                                            </div>
                                        );
                                    })}
                                </Carousel>
                            :   null
                    }
                </div>
            </div>
        </div>

    );

};

export default connect()(ContentPartner);
